@if (
  {
    selectedDepartment: selectedDepartment(),
  };
  as departmentInfo
) {
  <div class="tenant-selector-main-container-mobile">
    <div class="mobile-dialog-heading">
      <span class="mobile-heading-title">
        {{ 'Department' | translate }}
      </span>
      <mat-icon (click)="closeDialog()">close</mat-icon>
    </div>
    <div class="dialog-search-container-mobile mat-dialog-mobile-border-bottom">
      <app-ui-autocomplete
        [placeholder]="'search' | translate"
        [options]="searchableDepartments"
        [searchTerm]="form.searchTerm"
        [floatLabel]="'always'"
        [showList]="false"
      ></app-ui-autocomplete>
    </div>
    <div class="tenant-list-container">
      @for (department of filteredDepartments; track department) {
        <div
          class="department-single-container mat-dialog-mobile-border-top mat-dialog-mobile-border-bottom"
          (click)="selectDepartment(department.id)"
          [ngClass]="department.id === currentDepartmentId ? 'selected-dialog-list-item' : ''"
        >
          <div class="mobile-dep-image-container">
            <img
              width="50"
              height="50"
              class="rounded-border"
              [src]="(department.logo | appendDomain) || departmentPlaceHolderIconPath"
              alt="vessel picture"
            />
          </div>
          <div class="department-option-container">
            <span class="left-details-col">
              <h3>{{ department.name }}</h3>
              <span class="vessel-details">
                <div class="vessel-headings-row">
                  <span>LOA</span>
                  <span>DW</span>
                  <span>GRP</span>
                </div>
                <div class="vessel-info-row">
                  <span>-</span>
                  <span>-</span>
                  <span>-</span>
                </div>
              </span>
            </span>
            <span class="right-details-col">
              @if (department.id === departmentInfo.selectedDepartment?.id) {
                <span class="selected-marker">
                  <mat-icon>done</mat-icon>
                </span>
              }
            </span>
          </div>
        </div>
      }
      @if (filteredDepartments.length > 1 || form.searchTerm.value.contains(allDepsToken)) {
        <div
          (click)="selectDepartment(allDepsToken)"
          class="department-single-container mat-dialog-mobile-border-top mat-dialog-mobile-border-bottom"
          [ngClass]="allDepsToken === currentDepartmentId ? 'selected-dialog-list-item' : ''"
        >
          <div class="mobile-dep-image-container">
            <img
              width="50"
              height="50"
              class="rounded-border all-dep-image"
              [src]="allDepsIconPath"
              alt="vessel picture"
            />
          </div>
          <div class="department-option-container">
            <span class="left-details-col">
              <h3>{{ 'allDepartments' | translate }}</h3>
            </span>
            <span class="right-details-col">
              @if (allDepsToken === departmentInfo.selectedDepartment?.id) {
                <span class="selected-marker">
                  <mat-icon>done</mat-icon>
                </span>
              }
            </span>
          </div>
        </div>
      }
    </div>
  </div>
}
